import { createSlice } from '@reduxjs/toolkit';

import { IVacanciesRespondsState } from './interfaces';
import { loadVacanciesRespondsList } from './actions';

export const vacanciesRespondsSlice = createSlice({
  name: 'vacanciesResponds',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
  } as IVacanciesRespondsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadVacanciesRespondsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
  },
});
